export const defaultDecarbonizationPathways = [
  {
    "id": 1,
    "shortName": "I",
    "name": "PATHWAY 1"
  },
  {
    "id": 2,
    "shortName": "II",
    "name": "PATHWAY 2"
  },
  {
    "id": 3,
    "shortName": "III",
    "name": "PATHWAY 3"
  },
  {
    "id": 4,
    "shortName": "IV",
    "name": "PATHWAY 4"
  },
  {
    "id": 5,
    "shortName": "V",
    "name": "PATHWAY 5"
  }
];

export const defaultDecarbonizationLevers = [
  {
    "id": 1,
    "name": "Decarbonising gas",
    "selected": false,
    "totalCo2Emissions": 0,
    "subLevers": [
      {
        "id": 1,
        "name": "Gas to electric",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      },
      {
        "id": 2,
        "name": "Gas to CHP - Combined heat and power",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      },
      {
        "id": 3,
        "name": "Gas to biomass",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      },
      {
        "id": 4,
        "name": "Heat pumps",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      }
    ]
  },
  {
    "id": 2,
    "name": "Decarbonising fleet",
    "selected": false,
    "totalCo2Emissions": 0,
    "subLevers": [
      {
        "id": 5,
        "name": "Electric fleet",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      },
      {
        "id": 6,
        "name": "Hydrogen fleet",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      },
      {
        "id": 7,
        "name": "HVO (Hydrotreated vegetable oils)",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      }
    ]
  },
  {
    "id": 3,
    "name": "Decarbonising electricity",
    "selected": false,
    "totalCo2Emissions": 0,
    "subLevers": [
      {
        "id": 8,
        "name": "Solar",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      },
      {
        "id": 9,
        "name": "Wind",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      },
      {
        "id": 10,
        "name": "Hydrogen",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      },
      {
        "id": 11,
        "name": "REGOs (Renewable Energy Guarantee of Origin)",
        "emissionsSaved": null,
        "totalCo2Saved": null,
        "initialInvestmentPrice": null,
        "startYear": null,
        "endYear": null,
        "operationalCostPerYear": null,
        "selections": [
          {
            "pathwayId": 1,
            "selected": false
          },
          {
            "pathwayId": 2,
            "selected": false
          },
          {
            "pathwayId": 3,
            "selected": false
          },
          {
            "pathwayId": 4,
            "selected": false
          },
          {
            "pathwayId": 5,
            "selected": false
          }
        ]
      }
    ]
  }
];